import React, { useEffect, useState } from "react";
import "./catManagement.scss";
import { SearchBar } from "components/form";
import { categoryListApi } from "services/category";
import NotFound from "common/NotFound";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";

import { useSearchParams } from "react-router-dom";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import findSerialNumber from "utils/findSerialNumber";
import useFullPageLoader from "common/UseFullPageLoader";
import { CustomModal } from "components/modals/ModalBox";
import AddCat from "./AddCat";
import { limitOption } from "constants/staticData";
import Pagination from "react-js-pagination";

import useDebounce from "common/UseDebounce";
import EditCat from "./EditCat";
import { CgBlock } from "react-icons/cg";
import DeleteCategory from "./DeleteCategory";
import ChangeCategoryStatus from "./ChangeCategoryStatus";
import { userPlaceholder } from "assets/icons";

const CategoryManagement = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [searchParams, setSearchParams] = useSearchParams();

  const catTab = searchParams.get("type") || "CATEGORY";

  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);

  const [total, setTotal] = useState(null);

  const [catFetchedData, setFetchedCatData] = useState([]);

  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;

  // handle limit of page
  const handleLimit = (event) => {
    searchParams.set("limit", event.target.value);
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  const catDataFetchApiCall = async () => {
    try {
      onShow();

      const query = {
        type: catTab,
        page: activePage,
        limit: limit,
      };

      if (search && debouncedValue) {
        query.search = debouncedValue;
      }

      const {
        data: {
          data: { total, categories },
        },
        status,
        message,
      } = await categoryListApi(query);

      if (status === 200) {
        setFetchedCatData(categories);
        setTotal(total);
      }
    } catch (error) {
      console.log("Cat Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    catDataFetchApiCall();
  }, [catTab, activePage, limit, debouncedValue]);

  // ----------- Add Cat model

  const [addCategoryModalState, setAddCategoryModalState] = useState(false);
  const [editCategoryModalState, setEditCategoryModalState] = useState(false);
  const [categoryForEdit, setCategoryForEdit] = useState("");
  // common object to hold data

  const [selectedCategoryDetail, setSelectedCategoryDetail] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);

  // console.log("categoryForEdit:---------->", categoryForEdit);

  const closeModel = () => {
    setAddCategoryModalState(false);
    setEditCategoryModalState(false);
    setSelectedCategoryDetail({});
    setDeleteModal(false);
    setStatusModal(false);
  };

  // -------------show image model

  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  // show image preview handler
  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };
  // --------category-type-show-in-list------------------
  const handleCategory = (value) => {
    let categoryValue = []
    if (value.isSummer) {
      categoryValue.push('Summer')
    }
    if (value.isRainy) {
      categoryValue.push('Rain')
    }
    if (value.isWinter) {
      categoryValue.push('Winter')
    }
    return categoryValue.length > 0 ? categoryValue.join(', ') : 'N/A'

  }
  return (
    <>
      <div className="page_title has_child">
        <h3> Category Management</h3>
        <div className="tabContainer">
          <ul>
            {[
              { tabCatKey: "All Categories", tabData: "CATEGORY" },
              { tabCatKey: "Serious Illness", tabData: "SEASONALILLNESS" },
            ].map((mapProp, ind) => (
              <li
                key={ind}
                className={mapProp?.tabData === catTab ? "active" : "un-active"}
              >
                <button
                  type="button"
                  // className={
                  //   mapProp?.tabData === catTab ? "active" : "un-active"
                  // }
                  onClick={() => {
                    // setTabCat(mapProp?.tabData);
                    const setTabInstance = new URLSearchParams(searchParams);
                    setTabInstance.set("type", mapProp?.tabData);
                    setTabInstance.set("page", 1);

                    setSearchParams(setTabInstance);
                  }}
                >
                  {mapProp?.tabCatKey}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* -------category tabs */}

      {/* ----------tabs related data */}
      <div className="card">
        {loader}

        {/* ------search box and add category */}

        <div className="search-add-cat">
          {/* -search wrapper */}
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search..."}
              onChange={(e) => {
                setSearch(e.target.value);
                const searchIns = new URLSearchParams(searchParams);

                searchIns.set("page", 1);
                setSearchParams(searchIns);
              }}
              onKeyDown={(e) => {
                const allowedKeysRegex = /^[a-zA-Z0-9\- ]$/;
                const controlKeys = [
                  "Backspace",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                  "Tab",
                  "Escape",
                ];

                // Allow letters, numbers, space, hyphen
                if (
                  allowedKeysRegex.test(e.key) ||
                  controlKeys.includes(e.key)
                ) {
                  return;
                }

                // Block everything else
                e.preventDefault();
              }}
              value={search}
            />
          </div>

          {/* -----add cat button */}
          <div>
            <button
              className="button"
              onClick={() => {
                setAddCategoryModalState(true);
              }}
            >
              {" "}
              Add Category
            </button>
          </div>
        </div>

        {/* ------- menu header-------- */}

        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Icons</th>
                <th className="nowrap text-center">Category Name</th>
                <th className="nowrap text-center">Category Type</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {catFetchedData && catFetchedData.length ? (
                catFetchedData?.map((mapProp, index) => {
                  // console.log(mapProp?.image);
                  return (
                    <tr key={index}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, limit)}
                      </td>

                      <td className="nowrap text-center">
                        <img
                          src={mapProp?.image}
                          alt={mapProp?.name}
                          className="td-img"
                          onClick={() =>
                            showImagePreviewHandler(mapProp?.image)
                          }
                        />
                      </td>
                      <td className="nowrap text-center">{mapProp?.name}</td>
                      <td className="nowrap text-center">
                        {handleCategory(mapProp)}
                        {/* {mapProp?.isSummer ? 'Summary' : ""}
                        {mapProp?.isWinter ? 'Winter' : ""}
                        {mapProp?.isRainy ? 'Rainy' : ""} */}
                      </td>
                      <td className="nowrap text-center">
                        <div className="button-container">
                          {/* status change button */}

                          <button
                            type="button"
                            onClick={() => {
                              setSelectedCategoryDetail(mapProp);
                              setStatusModal(true);
                            }}
                          >
                            {mapProp?.status === "ACTIVE" ? (
                              <FaToggleOn size={18} />
                            ) : (
                              <FaToggleOff size={18} />
                            )}
                          </button>

                          {/* ---edit button */}

                          <button
                            type="button"
                            onClick={() => {
                              setEditCategoryModalState(true);
                              setCategoryForEdit(mapProp?._id);
                            }}
                          >
                            <FaEdit />
                          </button>

                          {/* ----delete Button */}

                          <button
                            type="button"
                            onClick={() => {
                              setSelectedCategoryDetail(mapProp);
                              setDeleteModal(true);
                            }}
                          >
                            <FaRegTrashAlt />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={7}
                  msg={"Category data not found"}
                  onHide={onHide}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ------image preview */}
      {showImagePreviewModel && (
        <CustomModal
          className={"sm image_preview_modal"}
          show={showImagePreviewModel}
          handleClose={() => {
            setImagePreview("");
            setShowImagePreviewModel(false);
          }}
        >
          <div className="image_preview">
            <img
              src={imagePreview || userPlaceholder}
              alt="user-profile-preview"
            />
          </div>
        </CustomModal>
      )}

      {addCategoryModalState && (
        <AddCat
          addCategoryModalState={addCategoryModalState}
          catDataFetchApiCall={catDataFetchApiCall}
          closeModel={closeModel}
          catTab={catTab}
        />
      )}

      {/* --status change */}

      {/* ------------------Change token Status*/}
      {statusModal && (
        <ChangeCategoryStatus
          selectedCategoryDetail={selectedCategoryDetail}
          onClose={() => closeModel()}
          catDataFetchApiCall={catDataFetchApiCall}
          statusModal={statusModal}
        />
      )}

      {/* ----------edit cat */}

      {editCategoryModalState && (
        <EditCat
          editCategoryModalState={editCategoryModalState}
          catDataFetchApiCall={catDataFetchApiCall}
          closeModel={closeModel}
          catTab={catTab}
          categoryForEdit={categoryForEdit}
        />
      )}

      {/* --------delete Category */}

      {/* Delete BANNER Modal */}
      {deleteModal && (
        <DeleteCategory
          deleteModal={deleteModal}
          selectedCategoryDetail={selectedCategoryDetail}
          catFetchedData={setFetchedCatData}
          closeModel={closeModel}
        />
      )}

      {/* ----------pagination */}

      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryManagement;
